import { Component, ElementRef, HostListener, NgZone, Renderer2, ViewChild } from '@angular/core';
import { animate, AnimationOptions } from 'popmotion';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import SwiperCore, { SwiperOptions } from 'swiper';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { EventsParams } from 'swiper/angular';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent {

  @ViewChild('heroBG') heroBG: ElementRef | undefined;
  @ViewChild('heroVideo') heroVideo: ElementRef | undefined;
  // @ViewChild('partnershipSection') partnershipSection: ElementRef | undefined;
  @ViewChild('partnershipSectionBG') partnershipSectionBG: ElementRef | undefined;
  @ViewChild('partnershipSectionTitle') partnershipSectionTitle: ElementRef | undefined;
  @ViewChild('pyArtwork') pyArtwork: ElementRef | undefined;

  isVideoOpen = false;

  partnershipAnimations: Array<{ stop: () => void; }> = [];

  springAnimationConfig: {type: 'spring', stiffness: number, damping: number, mass: number, duration: number, velocity: number} = {
    type: 'spring',
    mass: 1,
    stiffness: 7.11,
    damping: 4,
    duration: 800,
    velocity: 800,
  };

  partnershipAnimationConfig: {
    type: 'spring', stiffness: number, damping: number, mass: number, repeatDelay: number, bgRepeatType: string, titleRepeatType: string,
  } = {
    type: 'spring',
    mass: 1,
    stiffness: 80,
    damping: 80,
    repeatDelay: 1000,
    bgRepeatType: 'mirror',
    titleRepeatType: 'loop',
  };

  artworksModules = [
    { id: 1, name: 'Fundamentals of Python Development', img: '' },
    { id: 2, name: 'Classification', img: 'assets/images/artworks/module-2-img.png' },
    { id: 3, name: 'Regression', img: 'assets/images/artworks/module-3-img.png' },
    { id: 4, name: 'Clustring', img: 'assets/images/artworks/module-4-img.png' },
    { id: 5, name: 'Recommender systems', img: 'assets/images/artworks/module-5-img.png' },
    { id: 6, name: 'Artificial Neural Network (ANN)', img: 'assets/images/artworks/module-6-img.png' },
    { id: 7, name: 'Convolutional Neural Networks & Recurrent Neural Networks', img: 'assets/images/artworks/module-7-img.png' },
    { id: 8, name: 'A Complete Application of Modern Machine Learning', img: 'assets/images/artworks/module-8-img.png' },
    { id: 9, name: 'Portfolio Builder', img: 'assets/images/artworks/module-9-img.png' },
    { id: 10, name: 'Learn to Earn', img: 'assets/images/artworks/module-10-img.png' },
  ];

  selectedArtwork: { id: number, name: string, img: string } | null = null;

  config: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 24,
    navigation: false,
    pagination: false,
    scrollbar: false,
    // centeredSlides: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      480: {
        slidesPerView: 1.3,
      },
      767: {
        slidesPerView: 2.2,
      },
      // when window width is >= 991px
      991: {
        slidesPerView: 3,
      },
    },
  };

  students = [
    {
      id: 1,
      class: 'student-1',
      name: 'Kingsley Okoro',
      img: 'assets/images/student-vadin.png',
      bg: 'assets/images/student-vadin-bg.svg',
      testimonial: 'Part-way through the bootcamp, I had already started hitting my goals. My experience with the curriculum, instructors and TAs has been the best. If you are considering taking a bootcamp – JUST DO IT! You won’t regret it.',
    },
    {
      id: 2,
      class: 'student-2',
      name: 'Sahar Gargary',
      img: 'assets/images/student-kingsley.png',
      bg: 'assets/images/student-kingsley-bg.svg',
      testimonial: 'I can confidently compete in any industry needing data analysis, which is rapidly growing. This bootcamp is perfect for anyone needing a competitive advantage in the job market.',
    },
    {
      id: 3,
      class: 'student-3',
      name: 'Vadin Savanvkov',
      img: 'assets/images/student-sahar.png',
      bg: 'assets/images/student-sahar-bg.svg',
      testimonial: 'Since taking this bootcamp, I have more confidence in my data skills and abilities. Now I can confidently return to work and provide valuable insights on data and apply them to make smarter business decisions.',
    },
  ];

  logos = [
    { id: 1, img: 'assets/images/logo-ucce.png', link: '#' },
    { id: 2, img: 'assets/images/logo-wcs.png', link: '#' },
    { id: 3, img: 'assets/images/logo-cue.png', link: '#' },
    { id: 4, img: 'assets/images/logo-sait.png', link: '#' },
    { id: 5, img: 'assets/images/logo-apega.png', link: '#' },
  ];

  @HostListener('window:scroll', ['$event'])
  trackPartnershipScrollState() {
    // this.handlePartnershipSectionAnimation();
  }

  constructor(private renderer: Renderer2, private zone: NgZone) {
    this.selectedArtwork = this.artworksModules[0];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSwiper(params: any) {
    console.log(params);
  }
  onSlideChange() {
    console.log('slide change');
  }

  onStartHeroVideo() {
    const video = this.heroVideo?.nativeElement;
    if (video) {
      this.isVideoOpen = true;
      video.load();
      video.play();
      video.addEventListener('ended', () => {this.isVideoOpen = false},false);
    }
  }

  heroScrolledInView() {
    this.zone.runOutsideAngular(() => {
      this.animateHeroBG();
    });
  }

  heroScrolledOutOfView() {
    this.heroBG?.nativeElement.setAttribute('style', '');
  }

  partnershipScrolledInView() {
    console.log('partnership entered');
    this.zone.runOutsideAngular(() => {
      this.animatePartnership();
    });
  }
  
  partnershipScrolledOutOfView() {
    console.log('partnership exit');
    this.partnershipAnimations.forEach(animation => animation.stop());
    this.partnershipAnimations =[];
  }
  
  animateHeroBG(): void {
    const properties = [
      { name: 'left', from: 'calc(50% - 1279.64px/2 - 215.82px)', to: 'calc(75% - 1279.64px/2)' },
      { name: 'top', from: 'calc(50% - 659.65px/2 + 120.11px)', to: '0' },
      { name: 'opacity', from: '0.3', to: '1' },
      { name: 'transform', from: 'rotate(0)', to: 'rotate(-30.12deg)' },
    ];
    properties.forEach(prop => {
      animate(<AnimationOptions<string>>{
        from: prop.from,
        to: prop.to,
        duration: this.springAnimationConfig.duration,
        type: this.springAnimationConfig.type,
        stiffness: this.springAnimationConfig.stiffness,
        damping: this.springAnimationConfig.damping,
        mass: this.springAnimationConfig.mass,
        onUpdate: (value) => {
          this.renderer.setStyle(this.heroBG?.nativeElement, prop.name, value);
        },
      });
    });
  }

  animatePartnership(): void {
    const bgProperties = [
      { name: 'width', from: '60%', to: '100%' },
      { name: 'opacity', from: '1', to: '0.1' },
    ];
    const titleProperties = [
      { name: 'transform', from: 'translateX(-50px)', to: 'translateX(0px)' },
      { name: 'opacity', from: '0.1', to: '1' },
    ];
    bgProperties.forEach(prop => {
      const animation = animate(<AnimationOptions<string>>{
        from: prop.from,
        to: prop.to,
        type: this.partnershipAnimationConfig.type,
        stiffness: this.partnershipAnimationConfig.stiffness,
        damping: this.partnershipAnimationConfig.damping,
        mass: this.partnershipAnimationConfig.mass,
        repeat: Infinity,
        repeatDelay: this.partnershipAnimationConfig.repeatDelay,
        repeatType: this.partnershipAnimationConfig.bgRepeatType,
        onUpdate: (value) => {
          this.renderer.setStyle(this.partnershipSectionBG?.nativeElement, prop.name, value);
        },
      });
      this.partnershipAnimations.push(animation);
    });
    titleProperties.forEach(prop => {
      const animation = animate(<AnimationOptions<string>>{
        from: prop.from,
        to: prop.to,
        type: this.partnershipAnimationConfig.type,
        stiffness: this.partnershipAnimationConfig.stiffness,
        damping: this.partnershipAnimationConfig.damping,
        mass: this.partnershipAnimationConfig.mass,
        repeat: Infinity,
        repeatDelay: this.partnershipAnimationConfig.repeatDelay,
        repeatType: this.partnershipAnimationConfig.titleRepeatType,
        onUpdate: (value) => {
          this.renderer.setStyle(this.partnershipSectionTitle?.nativeElement, prop.name, value);
        },
      });
      this.partnershipAnimations.push(animation);
    });
  }

}
